import React from "react";

export default function NotificationDetail() {
  return <>Hello wolrd</>;
}
